import { render, staticRenderFns } from "./sysuser_auth_config.vue?vue&type=template&id=d963dc38&scoped=true"
import script from "./sysuser_auth_config.vue?vue&type=script&lang=js"
export * from "./sysuser_auth_config.vue?vue&type=script&lang=js"
import style0 from "./sysuser_auth_config.vue?vue&type=style&index=0&id=d963dc38&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d963dc38",
  null
  
)

export default component.exports